import { FormattedDate, FormattedMessage, useIntl } from "react-intl";
import { Dialog } from "../../../../common/core-ui/Dialog.tsx";
import styles from "./TermSwitcherDialog.module.scss";
import { clsx } from "clsx";
import { useState } from "react";

export interface TermSwitcherOption {
  label: string;
  value: string | number;
  startDate?: Date;
  endDate?: Date;
}

interface TermSwitcherDialogProps {
  options: TermSwitcherOption[];
  initialVal?: string | number;
  onRequestClose: (id?: string | number) => void;
}

export default function TermSwitcherDialog({
  options,
  initialVal,
  onRequestClose,
}: TermSwitcherDialogProps) {
  const intl = useIntl();
  const [selectedVal, setSelectedVal] = useState(initialVal);
  const dateProps: Intl.DateTimeFormatOptions = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  };

  return (
    <Dialog
      title={intl.formatMessage({ defaultMessage: "Change Term" })}
      onRequestClose={onRequestClose}
      primaryButton={{
        onClick: () => onRequestClose(selectedVal),
        label: intl.formatMessage({ defaultMessage: "Confirm" }),
      }}
      secondaryButton={{
        onClick: () => onRequestClose(),
        label: intl.formatMessage({ defaultMessage: "Cancel" }),
      }}
    >
      <fieldset className="vst-fieldset">
        <legend>
          <FormattedMessage
            defaultMessage={"Select a term to access those course materials."}
          />
        </legend>
        {options.map((option) => (
          <label
            key={option.value}
            className={clsx(
              styles.radioBlock,
              "vst-radio-check vst-radio-check-option-radio-checkmark"
            )}
          >
            <input
              type="radio"
              name="term"
              value={option.value}
              checked={option.value === selectedVal}
              onChange={() => {
                setSelectedVal(option.value);
              }}
            />
            <span className={styles.caption}>{option.label}</span>
            {option.startDate && option.endDate && (
              <span className={styles.date}>
                {/* FormattedDateTimeRange did not zero pad */}
                <FormattedMessage
                  defaultMessage={"{startDate} - {endDate}"}
                  values={{
                    startDate: (
                      <FormattedDate {...dateProps} value={option.startDate} />
                    ),
                    endDate: (
                      <FormattedDate {...dateProps} value={option.endDate} />
                    ),
                  }}
                />
              </span>
            )}
          </label>
        ))}
      </fieldset>
    </Dialog>
  );
}
